module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_9016.43a93912.png";